var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.isChair)?_c('div',{staticClass:"row chair-indicator"},[_vm._m(0)]):_vm._e()
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"col"},[_c('div',{staticClass:"alert alert-primary text-center",attrs:{"role":"alert"}},[_vm._v("\n            Chair\n        ")])])
}]

export { render, staticRenderFns }